import React from 'react';
import { Zap, Infinity as InfinityIcon } from 'lucide-react';
import './SessionCounter.css';

/**
 * Compact usage pill for the app navbar.
 * Props come from GET /usage: queriesUsed, queriesRemaining
 * (backend sends queries_remaining = 9999 for unlimited/exempt users).
 */
export default function SessionCounter({ queriesUsed = 0, queriesRemaining = 0 }) {
    if (queriesRemaining > 500) {
        return (
            <div className="session-counter unlimited" title="Unlimited queries">
                <InfinityIcon size={15} />
                <span className="counter-value">Unlimited</span>
            </div>
        );
    }

    const maxQueries = queriesUsed + queriesRemaining;
    const remainingPct = maxQueries > 0
        ? Math.min(100, Math.max(0, (queriesRemaining / maxQueries) * 100))
        : 0;
    const low = queriesRemaining <= 1;

    return (
        <div
            className={`session-counter ${low ? 'low' : ''}`}
            title={`${queriesRemaining} of ${maxQueries} queries left this period`}
        >
            <div className="counter-content">
                <Zap size={14} className="counter-icon" />
                <span className="counter-label">Queries</span>
                <span className="counter-value">{queriesRemaining}/{maxQueries}</span>
            </div>
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${remainingPct}%` }} />
            </div>
        </div>
    );
}
